import React, { useEffect, useState } from "react";
import DetailsModal from "./DetailsModal";
import { useParams, useLocation } from "react-router-dom";
import TicketActions from "../../Actions/TicketActions";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ticketStore from "../../Stores/TicketStores";
import TicketConstants from "../../Constants/TicketConstants";
import LanguageSelector from "../Language/LanguageSelector";

export default function PublicAccess() {
  const { language, localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [isDisable, setIsDisable] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [selticketId, setSelTicketID] = useState(null);
  const [closeReason, setCloseReason] = useState("");
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search);
  const ticketId = queryParam.get("t");
  const userId = queryParam.get("u");

  useEffect(() => {
    if (ticketId) {
      setGlobalSpinner(true);
      TicketActions.getTicketDetails(ticketId, userId, language, true);
    }
  }, [language]);

  useEffect(() => {
    function getSingleStatusUpdateSuccess() {
      var res = ticketStore.getResult();
      toast.success(localization.ticketUpdatedSuccess);
      TicketActions.getTicketDetails(ticketId, userId, language, true);
    }

    function getSingleStatusUpdateFailure() {
      var res = ticketStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_PUBLIC_TICKET_STATUS_SUCCESS,
      getSingleStatusUpdateSuccess
    );
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_PUBLIC__TICKET_STATUS_FAILURE,
      getSingleStatusUpdateFailure
    );
    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_PUBLIC_TICKET_STATUS_SUCCESS,
        getSingleStatusUpdateSuccess
      );
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_PUBLIC__TICKET_STATUS_FAILURE,
        getSingleStatusUpdateFailure
      );
    };
  }, [language, localization]);

  function handelUpdate() {
    setGlobalSpinner(true);
    TicketActions.UpdateStatus(
      {
        id: ticketId,
        status: "close",
        reason: closeReason,
      },
      true,
      language,
      false
    );
  }

  function handleButton(_value) {
    setIsShow(_value);
  }
  return (
    <>
      <header className="bs-docs-nav">
        <div className="container-fluid page-header">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 page-header-nav">
              <nav className="meta-nav">
                <ul id="navigator">
                  <li className="navi-item-list">
                    <LanguageSelector />
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-xs-8 col-xs-offset-2 col-sm-12 col-sm-offset-3 col-md-12 col-md-offset-0 col-lg-12 text-center logo-wrapper">
              <div id="header_image_wrapper"></div>
            </div>
          </div>
        </div>
      </header>
      <div id="publicAcessContainer" className="">
        <div className=" rowStyle mt-3">
          <div className="row ml-3 mr-0 mb-5 justify-content-center">
            <h1 className="headerRes">{localization.ticketdetails}</h1>
          </div>
          <DetailsModal
            showButton={handleButton}
            setTicketID={setSelTicketID}
            setIsDisable={setIsDisable}
          />
        </div>

        {isDisable && (
          <>
            <div className="row form-outline mt-4 mb-4">
              <input
                type="text"
                id="closeReason"
                name="closeReason"
                className="form-control"
                placeholder={localization.enterReason}
                required
                value={closeReason}
                onChange={(e) => {
                  setCloseReason(e.target.value);
                }}
              />
            </div>
            <div className="row ml-0 mr-5 justify-content-end fontStyle">
              <button
                type="button"
                onClick={handelUpdate}
                disabled={closeReason.trim() == ""}
                className="btn btn-primary mb-4 "
                style={{ backgroundColor: "#0078bb" }}
              >
                {localization.ticketClose}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
